export default "__VITE_ASSET__MK2JhpbA3gkhYbiHNwC77Q__"